<template>
    <div class="container card py-2 py-md-3" :class="{'border-danger':isOpenWaiting}">
        <div class="row">
            <div class="col-md-7 px-0 px-md-2">
                <div class="card-header p-2">
                    <div class="form-group form-check mb-0">
                        <input v-if="item.email_flg == '0'" type="checkbox" class="form-check-input" :disabled="!(item.summary_title && item.summary_sys)" @click="changeMailFlg(item.id, item.email_flg)" checked>
                        <input v-else type="checkbox" class="form-check-input" :disabled="!(item.summary_title && item.summary_sys)" @click="changeMailFlg(item.id, item.email_flg)">
                        <small>
                            <span v-if="item.rec_user_group">
                                {{item.rec_user_group_nm}}
                                &nbsp;/&nbsp;(
                                <a href="#" @click.prevent.stop="searchCompanyData(item.rec_user_group)">{{item.rec_user_group}}</a>
                                )
                            </span>
                            <span v-if="!(item.summary_title && item.summary_sys)">
                                <i class="fas fa-exclamation text-danger-cust"></i>
                            </span>
                            <span v-if="item.proj_user_group != item.rec_user_group && item.proj_user_group == 'none'">
                                <span>個人営業</span>
                                <span v-if="item.sales_name" class="text-nowrap">/{{item.sales_name}}</span>
                                <span v-else class="text-nowrap">/氏名無し</span>
                                <span class="text-nowrap">/{{item.email}}</span>
                            </span>
                        </small>
                    </div>
                    <div class="d-flex">
                        <div>
                            <span v-show="item.recent_in_day">
                                <small>
                                    In:{{item.recent_in_day | dformatw }}
                                </small>
                            </span>
                        </div>
                        <div v-show="item.recent_out_day" class="text-right flex-fill" :class="{'text-success': dateCompare(item.recent_out_day)}">
                            <small>
                                Out:{{item.recent_out_day | dformatw}}
                            </small>
                        </div>
                    </div>
                    <div class="mb-1">
                        <span v-if="item.proj_price_set == '0'" class="text-muted">
                            <i class="fas fa-yen-sign"></i>
                            <span class="icon-size text-danger-cust">
                                <span v-if="item.proj_price_start == '0'">~ {{item.proj_price_end}}</span>
                                <span v-else-if="item.proj_price_start == item.proj_price_end">{{item.proj_price_end}}</span>
                                <span v-else>{{item.proj_price_start}} ~ {{item.proj_price_end}}</span>
                            </span>
                            <span>万</span>
                        </span>
                        <span v-else class="text-nowrap text-danger-cust">
                            スキル見合い
                        </span>
                        <span v-if="item.proj_price_pub == '0'" class="text-nowrap text-success">
                            &nbsp;<i class="fas fa-comments-dollar"></i>
                            {{item.proj_price_pub_start}} ~ {{item.proj_price_pub_end}}万円
                        </span>
                        <!-- <span v-if="item.proj_place" class="text-nowrap text-muted"> -->
                        <!--     &nbsp;<i class="fas fa-map-marker"></i> -->
                        <!--     <small>{{item.proj_place}}</small> -->
                        <!-- </span> -->
                    </div>
                    <div class="mb-1">
                        <h4>
                            <span class="badge badge-secondary p-1" :class="{'badge-success':item.proj_remote_ok == '0'}">
                                <small>リモートOK</small>
                            </span>
                            <span class="badge badge-secondary p-1" :class="{'badge-success':item.proj_foreign_ok == '0'}">
                                <small>外国籍OK</small>
                            </span>
                            <span class="badge badge-secondary p-1" :class="{'badge-success':item.proj_is_adjust == '0'}">
                                <small>精算あり</small>
                            </span>
                        </h4>
                    </div>
                    <div class="mb-1">
                        <h4>
                            <span class="badge badge-warning px-2">
                                <small v-if="item.proj_language">{{item.proj_language}}</small>
                                <small v-else>言語未設定</small>
                            </span>
                            <span class="badge badge-warning px-2">
                                <small>{{editStartDate(item.proj_start_date)}}</small>
                            </span>
                            <span class="badge badge-warning px-2">
                                <small v-if="item.proj_min_exper">exp.{{item.proj_min_exper}}</small>
                                <small v-else>経験未設定</small>
                            </span>
                        </h4>
                    </div>
                    <div class="d-flex">
                        <div>
                            <span class="text-muted let-space-1">
                                <span :class="{'text-danger-cust':isWarnFinishDate(item.proj_finish_date)}">
                                    &nbsp;<i class="fas fa-hourglass-half"></i>
                                    <small>{{editFinishDate(item.proj_finish_date, 1)}}</small>
                                </span>
                                <span v-if="item.proj_position" class="text-nowrap">
                                    &nbsp;<i class="fas fa-sitemap"></i>
                                    <small>{{item.proj_position}}</small>
                                </span>
                                <span v-if="item.proj_members" class="text-nowrap">
                                    &nbsp;<i class="fas fa-user"></i>
                                    <small>{{item.proj_members}}名</small>
                                </span>
                                <span v-if="item.proj_place" class="text-nowrap">
                                    &nbsp;<i class="fas fa-map-marker"></i>
                                    <small>{{item.proj_place}}</small>
                                </span>
                            </span>
                        </div>
                        <div class="text-right flex-fill">
                            <span class="text-muted pl-2 ml-auto" @click="openMenu(item)">
                                <i class="fas fa-ellipsis-v"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="card-body pb-1 pt-1 px-2 item-hover item-big" @click="toProjDetail(item.id)">
                    <div class="let-space-1"><small>Pj.{{item.id}}</small></div>
                    <div>
                        <span v-if="item.proj_access_flg == '0'" class="text-nowrap border border-primary rounded px-1 text-primary">
                            <small>公開待ち</small>
                        </span>
                        <span v-else-if="item.proj_access_flg == '3'" class="text-nowrap border border-primary rounded px-1 text-primary">
                            <small>内部</small>
                        </span>
                        <span v-else-if="item.proj_access_flg == '2'" class="text-nowrap border border-primary rounded px-1 text-primary">
                            <small>閲覧制限</small>
                        </span>
                
                        <span v-if="item.proj_open_flg == '1'" class="text-nowrap border border-primary rounded px-1 text-primary">
                            <small>募集終了</small>
                        </span>
                        <span v-else-if="item.proj_open_flg == '2'" class="text-nowrap border border-primary rounded px-1 text-primary">
                            <small>削除待ち</small>
                        </span>
                        {{item.proj_nm}}
                    </div>
                </div>
            </div>
            <div class="col-md-5 px-0 px-md-2">
                <div class="card-body py-0 px-2 text-muted">
                    <div><small>必須スキル </small></div>
                    <div class="break-row"><small>{{item.proj_skill_need}} </small></div>
                    <div v-if="item.sys_note" class="border rounder py-1 px-2">
                        <div class="break-sys-note"><small>{{item.sys_note}} </small></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container px-0 text-muted let-space-1 pt-2">
            <div class="row">
                <div class="col-md-7 px-0 px-md-2">
                    <small class="px-2">
                        <i class="fas fa-pen"></i>
                        {{item.user_nm}} / {{item.proj_user_group}}
                    </small>
                </div>
                <div class="col-md-5 px-0 px-md-2">
                    <div class="card-body px-2 py-0 d-flex justify-content-between">
                        <div>
                            <small>
                                <i class="fas fa-calendar"></i>
                                {{item.created_at | dformatm}}
                            </small>
                        </div>
                        <div>
                            <small>
                                <i class="fas fa-sync"></i>
                                {{item.updated_at | dformatm}}
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {editProjStartDate
           ,editProjFinishDate
           ,isWarningProjFinishDate
           ,dateCompare
           } from 'pages/commons/form/comFunc'

    import {EventBus} from 'js/event-bus'

    export default {
        props: {
            item: Object
        },
        computed: {
            isOpenWaiting () {
                return this.$route.params.do != 'waiting' && this.item.proj_access_flg == '0' ? true : false
            }
        },
        methods: {
            searchCompanyData (rec_user_group) {
                this.$parent.$parent.searchCompanyData(rec_user_group)
            },
            changeMailFlg (id, flg) {
                this.$store.dispatch('changeCmpProjInfoCommon', {
                    id: id,
                    processId: 'emailFlg',
                    emailFlg: flg == '0' ? '1': '0'
                })
            },
            toProjDetail (id) {
                this.saveSelectedProjLocal(this.item.id)

                this.$router.push({name: 'CmpProjCreate', params:{
                    do: 'show',
                    id: id
                }})
            },
            saveSelectedProjLocal (id) {
                try {
                    localStorage.setItem('selectedProj', JSON.stringify(id))
                } catch (e) { }
            },
            openMenu (item) {
                EventBus.$emit('busOnCmpProjMenu', {
                    item: item,
                    opt: this.$route.params.do
                })
            },
            dateCompare (val) {
                return dateCompare(new Date, '=',  val, 'day')
            },
            editStartDate (val) {
                return editProjStartDate(val)
            },
            editFinishDate (val, p) {
                return editProjFinishDate(val, p)
            },
            isWarnFinishDate (val) {
                    return isWarningProjFinishDate(val)               
            },
        }
    }

</script>

<style lang="stylus" scoped>
.item-big:hover
    font-weight:bold
.break-row
    white-space: pre-wrap
    word-wrap: break-word

    overflow: hidden
    display: -webkit-box
    -webkit-box-orient: vertical
    -webkit-line-clamp: 7

.break-sys-note
    white-space: pre-wrap
    word-wrap: break-word

    overflow: hidden
    display: -webkit-box
    -webkit-box-orient: vertical
    -webkit-line-clamp: 2


</style>
